import { render, staticRenderFns } from "./form-verificationtoken.vue?vue&type=template&id=08f995ae&"
import script from "./form-verificationtoken.vue?vue&type=script&lang=js&"
export * from "./form-verificationtoken.vue?vue&type=script&lang=js&"
import style0 from "./form-verificationtoken.vue?vue&type=style&index=0&id=08f995ae&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports